import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { VideosService } from 'app/pages/status/videos/services/videos.service';
import { ErrorLoggerService } from 'app/services';
import { MediaService, MediaViewerItem } from 'app/services/media/media.service';
import { BaseComponent } from 'app/shared/components';
import { FilterPanelFilter } from 'app/shared/components/filter-panel/filter-panel.service';
import { showMediaViewerModal } from 'app/shared/components/media/viewer-modal/viewer-modal.component';
import { ModalService } from 'app/shared/components/modal';
import { AssetListItem, MediaInfoResponse } from 'app/shared/graphql';
import { debounce } from 'lodash';

@Component({
    selector: 'key-overview-details-video',
    templateUrl: 'details-video.component.html',
})
export class OverviewDetailsVideoComponent extends BaseComponent implements OnChanges {

    videoListLoaded = false;
    filters: FilterPanelFilter;
    page = 1;
    count = 1;
    errorMessage: string;

    videoList: MediaInfoResponse[] = [];
    debouncedLoadVideos = debounce(this.loadVideos, 800, { trailing: true, leading: false });

    timer: NodeJS.Timeout;

    @Input() asset: AssetListItem;

    @Input() isVisible: boolean;

    constructor(
        private videosService: VideosService,
        private media: MediaService,
        private modal: ModalService,
        private error: ErrorLoggerService
    ) {
        super();
        
        this.on(media.eventUpdated$, event => {
            if (event && event.eventType === 'video') {
                this.loadVideos({}, this.asset);
            }
        });

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.asset) {
            this.loadVideos({}, this.asset);
        }

        if (this.isVisible) {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.debouncedLoadVideos(this.filters, this.asset);
            }, 30e3);
        } else {
            clearInterval(this.timer);
        }
    }

    async loadVideos(filters: FilterPanelFilter, asset: AssetListItem) {

        try {
            filters = { ...filters, ...{ filters: { assets: [asset] }, limit: 20 } };
            this.filters = filters;
            this.videoListLoaded = false;
            const videoResult = await this.videosService.loadVideos(filters);

            if (this.count !== videoResult.count) {
                this.videoList = videoResult.items.map(x => ({
                    ...x,
                    thumbnailUrls: [this.media.getThumbnailsUrl(x.asset.id, {
                        date: x.date,
                        filename: x.filename,
                        input: x.input,
                        mediaType: 'video',
                    }
                    )],
    
                } as MediaInfoResponse));
                this.count = videoResult.count;
            }
            this.videoListLoaded = true;

        } catch (err) {
            this.showError(err);
        }

    }

    async onPagedChanged(page: number) {
        this.page = page;
        const updatedFilters = {...this.filters, ...{ page: page }};
        await this.loadVideos(updatedFilters, this.asset);
    }

    onItemSelected(event) {
        const media: MediaViewerItem = { 
            owner: event.owner,
            date: event.date,
            media: [{
                ...event.data.media,
                filename: event.filename,
                mediaType: event.mimeType,
            }],
            details: { 
                asset: event.asset,
            },
        };
        showMediaViewerModal(this.modal, media);
    }

    showError(error: any) {
        this.error.trackException(error);
        this.errorMessage = error ? error.message || error.error || error : null;
    }
}
